// extracted by mini-css-extract-plugin
module.exports =  {"focus-outline-hidden":"ThemeProvider__focus-outline-hidden___sfCL9"};